import Vue from "vue";

let Bus = (window.Bus = new Vue());

export default Bus;
